import { render, staticRenderFns } from "./AreaCard.vue?vue&type=template&id=0f19a845&scoped=true"
import script from "./AreaCard.vue?vue&type=script&lang=js"
export * from "./AreaCard.vue?vue&type=script&lang=js"
import style0 from "./AreaCard.vue?vue&type=style&index=0&id=0f19a845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19a845",
  null
  
)

export default component.exports